// TelcoTrack — validace záfuku (milník ZAFOUKNUTO, přechod na Zafouknutý, ROZVADEC).
// Ukončení v RD patří jen k milníku ZAVRTANY (`isZavrtMilestoneSpecValid`), ne k lineárnímu záfuku.

import { BUDOVA_BRANCH_ORIGIN_KIND } from './budova-branch-origin.constants';

/**
 * Záfuk picker lock: read-only, when source rozvaděč is already persisted
 * (spojkoviště Specifikovat / import / prior záfuk) or auto-set from a ROZVADEC-origin odbočka.
 * Missing FK (in-progress polygons) keeps the editable in-polygon picker as fallback.
 * Session-only záfuk pick is not a lock — validation still accepts it via resolveZafukRozvadecObjectId.
 */
export function isZafukRozvadecLockedFromFk(input: {
  persistedObjectId?: string | null;
  branchOriginKind?: string | null;
  branchRozvadecId?: string | null;
}): boolean {
  if (input.persistedObjectId?.trim()) return true;
  const origin = (input.branchOriginKind ?? '').trim().toUpperCase();
  return origin === BUDOVA_BRANCH_ORIGIN_KIND.ROZVADEC && !!input.branchRozvadecId?.trim();
}

export function isZafukMilestoneSpecValid(
  lengthM: number | null | undefined,
  rozId: string | null | undefined,
  vychoziBod = false,
): boolean {
  if (vychoziBod) return true;
  const length = lengthM;
  if (length == null || Number.isNaN(length) || length < 0) return false;
  return !!(rozId ?? '').trim();
}

/**
 * Lineární přechod na Zafouknutý (PHASE.2) / zafuk completion UI.
 * Vyžaduje jen záfuk (délka + rozvaděč / výchozí bod) — **ne** `ukonceni_v_rd`.
 * Extra args retained for call-site compatibility; ignored.
 */
export function isZafukPhaseTransitionValid(
  _buildingType: string | null | undefined,
  lengthM: number | null | undefined,
  rozId: string | null | undefined,
  _ukonceniVRd?: string | null | undefined,
  _ukonceniVRdOther?: string | null | undefined,
  vychoziBod = false,
): boolean {
  return isZafukMilestoneSpecValid(lengthM, rozId, vychoziBod);
}

/** Délka záfuku z metráží OK (|konec − start|); parita backend `deriveZafukLengthMFromOkMetraz`. */
export function recomputeZafukLengthFromOkMetraz(
  startM: number | null | undefined,
  konecM: number | null | undefined,
): number | null {
  const start = startM;
  const konec = konecM;
  if (
    start == null ||
    konec == null ||
    Number.isNaN(start) ||
    Number.isNaN(konec)
  ) {
    return null;
  }
  return Math.round(Math.abs(konec - start) * 100) / 100;
}

export function parseZafukMetaDouble(raw: unknown): number | null {
  if (typeof raw === 'number') {
    return Number.isFinite(raw) && raw >= 0 ? raw : null;
  }
  if (typeof raw === 'string' && raw.trim()) {
    const n = Number.parseFloat(raw.trim().replace(',', '.'));
    return Number.isFinite(n) && n >= 0 ? n : null;
  }
  return null;
}
